import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';
import { get_integration_status_summary, is_integration_configured } from '../integrationCatalog';

const IntegrationCard = ({
    integration_key,
    image,
    tags = [],
    variant = 'catalog',
    config = null,
    onActivate,
    onConfigure,
}) => {
    const { t } = useTranslation();
    const title = t(`settings.integrations.${integration_key}.title`);
    const status_summary = variant === 'active'
        ? get_integration_status_summary(integration_key, config, t)
        : null;

    const is_configured = variant === 'active'
        && is_integration_configured(integration_key, config);

    const handle_click = () => {
        if (variant === 'active')
            onConfigure?.(integration_key);
        else
            onActivate?.(integration_key);
    };

    return (
        <div
            className={`IntegrationCard IntegrationCard--${variant}`}
            onClick={handle_click}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ')
                    handle_click();
            }}
        >
            <div className="IntegrationCard-logo">
                <img src={image} className="img rounded" alt={title} />
            </div>
            <div className="IntegrationCard-body">
                <div className="IntegrationCard-header">
                    <h3 className="IntegrationCard-title">{title}</h3>
                    {variant === 'active' && (
                        <Badge
                            color={is_configured ? 'success' : 'warning'}
                            className="IntegrationCard-badge"
                        >
                            {t(is_configured
                                ? 'settings.integrations.active_badge'
                                : 'settings.integrations.not_configured_badge')}
                        </Badge>
                    )}
                </div>
                {variant === 'catalog' && (
                    <p className="IntegrationCard-description">
                        {t(`settings.integrations.${integration_key}.description`)}
                    </p>
                )}
                {variant === 'active' && status_summary && (
                    <p className="IntegrationCard-summary">{status_summary}</p>
                )}
                {variant === 'catalog' && tags.length > 0 && (
                    <div className="IntegrationCard-tags">
                        {tags.map(tag => (
                            <Badge key={tag} color="secondary" className="IntegrationCard-tag">
                                {t(`settings.integrations.tags.${tag}`)}
                            </Badge>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default IntegrationCard;
